import { Injectable } from '@angular/core';
import { FormControlServiceBase } from '../types/form-control-service.base';

@Injectable({
  providedIn: 'root'
})
export class EmailFormControlService implements FormControlServiceBase<'email'> {

  constructor() {

  }


}


